import { Link } from "react-router-dom";
import { Truck } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="page-404" className="min-h-[70vh] grid place-items-center px-6">
      <div className="text-center max-w-md">
        <span className="inline-grid place-items-center h-12 w-12 rounded-xl bg-[#00274C] border border-white/10 mx-auto">
          <Truck className="h-5 w-5 text-[#FFCB05]" />
        </span>
        <h1 className="mt-6 font-display text-4xl font-medium tracking-tight text-white">Off the route.</h1>
        <p className="mt-3 text-[#9CA3AF]">That page doesn’t exist. Let’s get you back on the road.</p>
        <Link
          to="/"
          data-testid="404-home-btn"
          className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full text-sm font-semibold bg-[#FFCB05] text-[#040914] hover:bg-[#FFD633] transition-colors"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
